const en = {
    title: 'Available traffic',
    refresh: 'Refresh',
    refreshing: 'Updating…',
    loading: 'Loading traffic balance…',
    waiting: 'Waiting for connection',
    updated: 'Updated',
    unavailable: 'Unable to load traffic balance. Please try again.',
    stale: 'Unable to update. Showing the last known balance.',
    exhausted: 'No traffic remaining',
    details: 'Traffic details',
    allocated: 'Total allocated',
    used: 'Total used',
    healthy: 'Traffic available',
    warning: 'Less than 2 GiB remaining',
    low: 'Less than 1 GiB remaining',
}

const ru: Record<keyof typeof en, string> = {
    title: 'Доступный трафик',
    refresh: 'Обновить',
    refreshing: 'Обновляем…',
    loading: 'Загружаем остаток трафика…',
    waiting: 'Ожидаем подключения',
    updated: 'Обновлено',
    unavailable: 'Не удалось загрузить остаток трафика. Попробуйте ещё раз.',
    stale: 'Не удалось обновить. Показан последний известный остаток.',
    exhausted: 'Доступный трафик закончился',
    details: 'Подробности о трафике',
    allocated: 'Выделено всего',
    used: 'Использовано всего',
    healthy: 'Трафик доступен',
    warning: 'Осталось меньше 2 ГиБ',
    low: 'Осталось меньше 1 ГиБ',
}

export const trafficMessages = { en, ru }
